import React, {useRef} from "react";
import {connect} from "react-redux";
import {withStyles} from "@material-ui/core";
import ClientVersionsCheckList from "./ClientVersionsCheckList";
import {hasPermission} from "../../sc-utilities";

const styles = theme => ({
    root: {
        height: 'auto',
        marginTop: theme.spacing(),
        paddingLeft: theme.spacing(),
        paddingRight: theme.spacing(),
        [theme.breakpoints.down('sm')]: {
            padding: 0,
            margin: 0,
            width: '100%'
        }
    }
});

const ClientVersionsCheck = (props) => {
    const tableRef = useRef();
    const { classes, activeCustomerID, translations, permissions } = props;

    return (
        <div className={classes.root}>
            {hasPermission(permissions, 'client_type_usage') &&
            <ClientVersionsCheckList tableRef={tableRef} activeCustomerID={activeCustomerID} translations={translations} permissions={permissions} />}
        </div>
    )
}

const mapStateToProps = state => {
    return {
        activeCustomerID: state.core.login.activeCustomer.CustomerID,
        translations: state?.translate?.translations?.activeTranslations || {},
        permissions: state?.core?.login?.permissions || [],
    };
};

export default connect(mapStateToProps, null)(withStyles(styles, { withTheme: true })(ClientVersionsCheck));